import emailjs from '@emailjs/browser';
import {useState} from "react";



const useSubmit = () => {
  const [isLoading, setLoading] = useState(false);
  const [response, setResponse] = useState(null);

  const submit = async (url, data) => {
    
    setLoading(true);
    try {
      await emailjs.send("service_ea7v0lk", 'template_7oneao6', data , '3BZOggY_RiptZ6M_0');
      setResponse({
        type: 'success',
        message: `Thanks for your submission ${data.name}, we will get back to you shortly!`,
      });
    } catch (error) {
      setResponse({
        type: 'error',
        message: `Something went wrong, please try again later!`,
      });
    } finally {
      setLoading(false);
    }
  };


  return { isLoading, response, submit };
}

export default useSubmit;
